/**
 * "1st", "2nd", "3rd", "4th" … "11th", "12th", "13th", "21st" — for the
 * hit-again chain's steps and its limit sentence.
 * For Media Devoted | Created By Ciro Autiero
 */
export function ordinal(n: number): string {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  return `${n}${({ 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[n % 10] ?? 'th'}`;
}
